import { toast } from "react-toastify";
import APIPaths from "../../utils/APIPaths";
import RoutingPaths from "../../utils/RoutingPaths";
import axiosInstance from "../axiosInstance";

export const clientSignUpService = async (bodyObj, navigate) => {
  try {
    const response = await axiosInstance.post(APIPaths.CLIENT_SIGN_UP, bodyObj);

    if (response.status === 201) {
      navigate(RoutingPaths.PROFILE_VERIFY);
      toast.success(response.data?.message);
    }

    return response;
  } catch (error) {
    const errorMessage =
      error.response?.data?.message ?? "An error occurred while signing up.";
    toast.error(errorMessage);
    return;
  }
};

export const clientLoginService = async (bodyObj, navigate) => {
  try {
    const { data } = await axiosInstance.post(APIPaths.CLIENT_SIGN_IN, bodyObj);
    const { token } = data.data;

    if (token) {
      sessionStorage.setItem("token", token);
      sessionStorage.setItem(
        "ClientDetails",
        JSON.stringify(data.data?.clientDto)
      );
      navigate(RoutingPaths.CONTACT_DETAIL);
      toast.success("Logged in successfully.");
      return;
    }
  } catch (error) {
    toast.error("The provided email ID or password is invalid.");
    return;
  }
};

export const getClient = async (value) => {
  try {
    const URL = APIPaths.GET_CLIENT;
    const response = await axiosInstance.get(URL);
    if (response.status === 200) {
      return response.data;
    }
    return [];
  } catch (error) {}
};

export const clientForgotPasswordService = async (bodyObj, navigate) => {
  try {
    const response = await axiosInstance.post(
      APIPaths.CLIENT_FORGOT_PASSWORD,
      bodyObj
    );

    if (response.status === 200) {
      navigate(
        RoutingPaths.FORGOT_PASSWORD_VALIDATE_TOKEN + "/" + bodyObj.userType,
        {
          state: {
            userName: bodyObj?.userName,
          },
        }
      );
      toast.success(response.data?.message);
    }

    return response;
  } catch (error) {
    const errorMessage =
      error.response.data.message ??
      error.response?.data ??
      "An error occurred while validating email.";
    toast.error(errorMessage);
    return;
  }
};

export const clientForgotPasswordValidateTokenService = async (
  bodyObj,
  navigate
) => {
  try {
    const response = await axiosInstance.post(
      APIPaths.CLIENT_FORGOT_PASSWORD_VALIDATE_TOKEN,
      bodyObj
    );
    if (response.status === 200) {
      navigate(RoutingPaths.FORGOT_PASSWORD_CHANGE + "/" + bodyObj.userType, {
        state: {
          userName: bodyObj?.userName,
          bodyObj,
        },
      });
      toast.success(response.data?.message);
    }

    return;
  } catch (error) {
    const errorMessage =
      error.response?.data?.message ??
      "An error occurred while validating token.";
    toast.error(errorMessage);
    return;
  }
};

export const clientForgotPasswordChangeService = async (bodyObj, navigate) => {
  try {
    const response = await axiosInstance.post(
      APIPaths.CLIENT_FORGOT_PASSWORD_CHANGE,
      bodyObj
    );

    if (response.status === 200) {
      navigate(RoutingPaths.LOGIN);
      toast.success(response.data?.message);
    }

    return response;
  } catch (error) {
    if (error.response?.data?.errors?.newPassword) {
      toast.error(error.response?.data?.errors?.newPassword);
    } else {
      toast.error(error.response?.data?.message);
    }
    return;
  }
};

export const getConsultantsForClient = async (orgId) => {
  try {
    const URL = APIPaths.GET_CONSULTANTS_FOR_CLIENT + orgId;
    const response = await axiosInstance.get(URL);
    if (response.status === 200) {
      return response.data;
    }
    return [];
  } catch (error) {}
};

export const getOrganizationList = async () => {
  try {
    const URL = APIPaths.GET_ORGANIZATION_LIST;
    const response = await axiosInstance.get(URL);
    if (response.status === 200) {
      return response.data;
    }
    return [];
  } catch (error) {}
};

export const shareDocumentByDocumentId = async (bodyObj) => {
  try {
    const response = await axiosInstance.post(
      APIPaths.SHARE_CLIENT_DOCUMENT,
      bodyObj
    );

    if (response.status === 201) {
      return response;
    }
  } catch (error) {
    if (error.response.data.errors) {
      for (const item in error.response.data.errors) {
        toast.error(error.response.data.errors[item]);
      }
    } else {
      toast.error(error.response.data);
    }
    return;
  }
};

export const getPackagesListByClientId = async (clientId) => {
  const response = await axiosInstance
    .get(`${APIPaths.GET_PACKAGES_BY_CLIENT_ID}/${clientId}`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      toast.error("Failed to fetch package list.");
      console.error("Error fetching package list:", error);
      return [];
    });
  return response;
};

/**
 *
 * @param {*} clientId
 * @returns list of medical procedure items based selected clientId and consultantId
 */
export const getAllMedicalProcedureByClientId = async (clientId) => {
  try {
    const URL = `${APIPaths.GET_TREATMENT_PLAN_BY_CLIENT_ID}${clientId}`;
    const response = await axiosInstance.get(URL);
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    if (error.response.data.errors) {
      for (const item in error.response.data.errors) {
        toast.error(error.response.data.errors[item]);
      }
    } else {
      toast.error(error.response.data);
    }
  }
};

export const addAcceptanceClientConsentForm = async (bodyObj) => {
  try {
    const URL = APIPaths.ACCEPT_CLIENT_CONSENT_FORM;
    const response = await axiosInstance.post(URL, bodyObj);
    if (response.status === 201) {
      return response;
    }
  } catch (error) {
    if (error.response.data.errors) {
      for (const item in error.response.data.errors) {
        toast.error(error.response.data.errors[item]);
      }
    } else {
      toast.error(error.response.data);
    }
  }
};

export const getClientConsentFormByClientId = async (
  page,
  rowsPerPage,
  clientId
) => {
  try {
    const response = await axiosInstance.get(
      `${APIPaths.GET_ACCEPTED_CONSENT_FORM_BY_CLIENT_ID}/${clientId}/${page}/${rowsPerPage}`
    );
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    console.error("Error fetching consent form info", error);
  }
};

export const downloadClientConsentFormPDFById = async (id, data) => {
  try {
    const URL = `${APIPaths.GET_ACCEPTED_CONSENT_PDF_BY_ID}/${id}`;
    const response = await axiosInstance.get(URL, {
      params: {
        layoutInstructionDto: data,
      },
      responseType: "arraybuffer",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });

    if (response.status === 200) {
      toast.success("File downloaded successfully");
      const url = window.URL.createObjectURL(new Blob([response.data]));
      return url;
    } else if (response.status === 204) {
      toast.warning("Consent form not available");
    }
  } catch (error) {
    toast.error("File download failed");
    console.error(error);
  }
};

export const viewClientConsentFormPDFByID = async (id, data) => {
  try {
    const URL = `${APIPaths.GET_ACCEPTED_CONSENT_PDF_BY_ID}/${id}`;
    const response = await axiosInstance.get(URL, {
      params: {
        layoutInstructionDto: data,
      },
      responseType: "blob",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });

    if (response.status === 200) {
      const url = window.URL.createObjectURL(response.data);
      return url;
    }
  } catch (error) {
    toast.error("View document failed");
  }
};

export const withdrawClientConsentByClientId = async (id) => {
  try {
    const URL = APIPaths.WITHDRAW_CONSENT_BY_ID;
    const response = await axiosInstance.put(URL + "/" + id);
    if (response.status === 200) {
      return response;
    }
  } catch (error) {
    if (error.response.data.errors) {
      for (const item in error.response.data.errors) {
        toast.error(error.response.data.errors[item]);
      }
    } else {
      toast.error(error.response.data);
    }
  }
};

export const sendOTP = async (value, clientId, consentAcceptanceDto) => {
  try {
    const URL = `${APIPaths.SEND_OTP_TO_ACCEPT_CONSENT}/${value}/${clientId}`;
     const response = await axiosInstance.post(URL,consentAcceptanceDto); 

    if (response.status === 200) {
      return response;
    }
  } catch (error) {
    if (error.response.data.errors) {
      for (const item in error.response.data.errors) {
        toast.error(error.response.data.errors[item]);
      }
    } else {
      toast.error(error.response.data);
    }
  }
};

export const getAdditionalInfoList = async (organizationId) => {
  try {
    const URL = APIPaths.GET_ADDITIONAL_INFO_LIST_BY_ORG_ID + organizationId;
    const response = await axiosInstance.get(URL);
    if (response.status === 200) {
      return response.data;
    }
    return [];
  } catch (error) {}
};

export const downloadConsentFormPDF = async (consentFormId, data) => {
  try {
    const URL = `${APIPaths.DOWNLOAD_CONSENT_FORM}/${consentFormId}`;
    const response = await axiosInstance.get(URL, {
      params: {
        layoutInstructionDto: data,
      },
      responseType: "arraybuffer",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });

    if (response.status === 200) {
      toast.success("File downloaded successfully");
      const url = window.URL.createObjectURL(new Blob([response.data]));
      return url;
    } else if (response.status === 204) {
      toast.warning("Consent Form not available");
    }
  } catch (error) {
    toast.error("File download failed");
  }
};

export const viewConsentFormPDF = async (consentFormId, data) => {
  try {
    const URL = `${APIPaths.DOWNLOAD_CONSENT_FORM}/${consentFormId}`;
    const response = await axiosInstance.get(URL, {
      params: {
        layoutInstructionDto: data,
      },
      responseType: "blob",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });

    if (response.status === 200) {
      const url = window.URL.createObjectURL(response.data);
      return url;
    }
  } catch (error) {
    toast.error("View file failed");
  }
};

export const deleteClientById = async (clientId, navigate) => {
  try {
    const URL = `${APIPaths.DELETE_CLIENT_BY_ID}${clientId}`;
    const response = await axiosInstance.delete(URL);
    if (response && response.data) {
      toast.success(response.data);
    } else {
      toast.success("Client deleted successfully!");
    }
    navigate(RoutingPaths.CONTACTS);
  } catch (error) {
    if (error.response && error.response.data) {
      toast.error(error.response.data);
    } else {
      toast.error("An unexpected error occurred.");
    }
    console.error(error);
  }
};

export const getTotalClients = async (data) => {
  try {
    const URL = `${APIPaths.GET_TOTAL_CLIENTS}`;
    const response = await axiosInstance.get(URL, {
      params: {
        from: data.from,
        to: data.to,
        interval: data.interval,
      },
    });
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    toast.error(
      "An error occurred while fetching total clients. Please try again."
    );
  }
};

export const mergeClientRecords = async (clientIdToKeep, clientIdToDelete) => {
  try {
    const URL = `${APIPaths.MERGE_CLIENT_RECORDS}/${clientIdToKeep}/${clientIdToDelete}`;
    const response = await axiosInstance.post(URL);

    if (response.status === 200) {
      toast.success(response.data.message);
      return response.data;
    }
  } catch (error) {
    if (error.response.data.errors) {
      for (const item in error.response.data.errors) {
        toast.error(error.response.data.errors[item]);
      }
    } else {
      if (error.response.data) {
        toast.error(error.response.data);
      } else {
        toast.error("Something went wrong!");
      }
    }
  }
};

export const getPatientRecordListByClientId = async (clientId) => {
  const response = await axiosInstance
    .get(`${APIPaths.GET_PATIENT_VACCINE_RECORDS_BY_CLIENT_ID}/${clientId}`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      toast.error("Failed to fetch vaccine schedule list.");
      console.error("Error fetching package list:", error);
      return [];
    });
  return response;
};

export const createImmunizationScheduleForClient = async (clientId) => {
  try {
    const URL = `${APIPaths.CREATE_IMMUNIZATION_SCHEDULE}${clientId}`;
    const response = await axiosInstance.post(URL);

    if (response.status === 200) {
      toast.success(response.data.message);
      return response.data;
    }
  } catch (error) {
    if (error.response.data.errors) {
      for (const item in error.response.data.errors) {
        toast.error(error.response.data.errors[item]);
      }
    } else {
      if (error.response.data) {
        toast.error(error.response.data);
      } else {
        toast.error("Something went wrong!");
      }
    }
  }
};

export const downloadClientImmunizationSchedulePDFByClientId = async (
  clientId
) => {
  try {
    const URL = `${APIPaths.DOWNLOAD_IMMUNIZATION_SCHEDULE_BY_CLIENT_ID}/${clientId}`;
    const response = await axiosInstance.get(URL, {
      responseType: "arraybuffer",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });

    if (response.status === 200) {
      toast.success("Immunization schedule downloaded successfully");
      const url = window.URL.createObjectURL(new Blob([response.data]));
      return url;
    } else if (response.status === 204) {
      toast.warning("Immunization Schedule not available");
    }
  } catch (error) {
    toast.error("File download failed");
    console.error(error);
  }
};

export const updatePatientRecord = async (patientVaccineRecordId, bodyObj) => {
  try {
    const URL = `${APIPaths.UPDATE_PATIENT_VACCINE_RECORD}/${patientVaccineRecordId}`;
    const response = await axiosInstance.put(URL, bodyObj);
    if (response && response.status === 200) {
      return response.data;
    }
    return null;
  } catch (error) {
    toast.error(error.response.data);
    return null;
  }
};

export const addVaccineScheduelToPatientVaccineRecord = async (clientId, vaccineScheduleId) => {
  try {
    const URL = `${APIPaths.ADD_VACCINE_SCHEDUELE_TO_PATIENT_VACCINE_RECORD}/${clientId}/${vaccineScheduleId}`;
    const response = await axiosInstance.post(URL);

    if (response && response.status === 200) {
      return response.data;
    }
    return null;
  } catch (error) {
    toast.error(error.response.data);
    return null;
  }
};

/**
 *
 * @param {*} clientId
 * @returns list of vaccines to be paid by clientId
 */
export const getVaccinesToBePaidByClientIdList = async (
  clientId,
  consultantId
) => {
  try {
    const URL = `${APIPaths.GET_VACCINES_TO_BE_PAID_BY_CLIENT_ID}${clientId}`;
    const response = await axiosInstance.get(URL);
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    if (error.response.data.errors) {
      for (const item in error.response.data.errors) {
        toast.error(error.response.data.errors[item]);
      }
    } else if (error.response.data) {
      toast.error(error.response.data);
    } else {
      toast.error("Something went wrong");
    }
  }
};

export const getGrowthChartDataByClientId = async (clientId) => {
  try {
    const URL = `${APIPaths.GET_GROWTH_CHART_DATA_BY_CLIENT_ID}${clientId}`;
    const response = await axiosInstance.get(URL);

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    if (error.response.data.errors) {
      for (const item in error.response.data.errors) {
        toast.error(error.response.data.errors[item]);
      }
    } else if (error.response.data) {
      toast.error(error.response.data);
    } else {
      toast.error("Something went wrong");
    }
  }
};

export const downloadGrowthChartPDF = async (data, clientId) => {

  try {
    const URL = APIPaths.DOWNLOAD_GROWTH_CHART_PDF + clientId;
    const response = await axiosInstance.post(URL,JSON.stringify(data),{ responseType: 'arraybuffer'});
    if (response.status === 200) {
      toast.success("File downloaded successfully");
      const url = window.URL.createObjectURL(new Blob([response.data]));
      return url;
    }
  } catch (error) {
    console.error("Error downloading PDF:", error);
  }
};
